export default {"gitHash":"59cae1a1f72f2b63c6dae688d8e405be3f760da4","gitHashShort":"59cae1a","time":1650386341503,"platform":"linux","arch":"x64"};